import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6416b188&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6416b188",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\haima\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6416b188')) {
      api.createRecord('6416b188', component.options)
    } else {
      api.reload('6416b188', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6416b188&scoped=true", function () {
      api.rerender('6416b188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/goodList/goodListFrom/index.vue"
export default component.exports